import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=6f0a0a62&scoped=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=js"
export * from "./AddProjectModal.vue?vue&type=script&lang=js"
import style0 from "./AddProjectModal.vue?vue&type=style&index=0&id=6f0a0a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a0a62",
  null
  
)

export default component.exports